export default __webpack_public_path__ + "beta-maps-guides-migrate-approximate-location-1200-dc2b6c76095e2b73f3ff6a4d6533a1cc.png";